




















import { ModalHelper } from '@/helpers/modal-helper';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { providerPageExpTrackEvent } from '@/helpers/experiments/popular-provider-page-exp-helper';
import { AccountModal, SettingsModal } from '@/lazy-load-components';

const User = namespace('user');

@Component({ name: 'LoginMenuButton' })
export default class LoginMenuButton extends Vue {
	loading: boolean = false;

	@User.Getter isLoggedIn: (providerName?: string) => boolean;
	@User.State loginProgress: boolean;

	async handleLoginClick() {
		this.loading = true;

		if (this.isLoggedIn()) {
			await ModalHelper.openModal(SettingsModal, { closable: true });
		} else {
			providerPageExpTrackEvent({ action: 'click', label: 'modal_opened_user_account' });
			await ModalHelper.openModal(
				AccountModal,
				{ closable: true },
				{ cssClass: 'account-modal' },
				'LoginMenuButton'
			);
		}

		this.loading = false;
	}
}
